var n = /* @__PURE__ */ ((i) => (i.Menu = "menu", i.List = "list", i.Listbox = "listbox", i.Nav = "nav", i))(n || {});
const l = ["menu", "list", "listbox", "nav"];
var t = /* @__PURE__ */ ((i) => (i.Stack = "stack", i.Inline = "inline", i.InlineEqualWidth = "inline-equal-width", i))(t || {});
const s = ["stack", "inline", "inline-equal-width"];
export {
  s as MENU_LAYOUTS,
  l as MENU_ROLES,
  t as MenuLayout,
  n as MenuType
};
